<template>
  <div
    class="exhibitionDeatil"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section eng_section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibition">Regong Works Exhibition</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ detail.englishName }}</span>
        </div>
      </div>
    </div>
    <div class="exhibitionMiddle">
      <div class="section">
        <div class="exhibitionContent">
          <div class="title eng_title">
            <div>{{ detail.englishName }}</div>
            <div @click="goBottom" class="gobottom" v-if="detail.englishName">
              {{ detail.englishName }}&nbsp;Online Art Exhibition
            </div>
          </div>
          <div class="content eng_content" v-if="detail.englishProfile&&detail.englishProfile.replace(/<[^<>]+>/g, '') !== ''">
            <div
              v-if="detail.englishProfile&&detail.englishProfile.replace(/<[^<>]+>/g, '') !== ''"
              class="one wow animate__fadeInDown animate__animated"
              v-html="detail.englishProfile"
            ></div>
          </div>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <!-- 介绍人 -->
    <div class="introduction" v-if="detail.dutyPicture&&detail.dutyPicture.length>0||detail.englishDutyProfile&&detail.englishDutyProfile.replace(/<[^<>]+>/g, '') !== ''">
      <div class="section">
        <div class="characterIntroduction">
          <div class="title eng_title" v-if="detail.englishDuty">
            {{ detail.englishDuty }}&nbsp;Introduction
          </div>
          <div class="imgBox" v-if="detail.dutyPicture&&detail.dutyPicture.length>0">
            <div
              class="swiper-containers wow animate__fadeInLeft animate__animated"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide item"
                  v-for="(item, index) in detail.dutyPicture"
                  :key="index"
                >
                  <img
                    v-if="item.fileUrl"
                    class="img"
                    :src="url + item.fileUrl"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="content eng_content" v-if="detail.englishDutyProfile.replace(/<[^<>]+>/g, '') !== ''">
            <div
              v-if="detail.englishDutyProfile.replace(/<[^<>]+>/g, '') !== ''"
              class="one wow animate__fadeInDown animate__animated"
              v-html="detail.englishDutyProfile"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="deatilBottom" id="deatilBottom">
      <div class="section">
        <swiper
          :options="swiperOption"
          v-if="categoryList.length > 3"
          ref="mySwiper"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in categoryList"
            :key="index"
            style="
              position: relative;
              overflow: hidden;
              width: 360px;
              height: 266px;
            "
          >
            <div class="typeMask hidden-xs-only" @click="goPaintingExhibition(item.id)">
              <div class="Itemtitle eng_Itemtitle">{{ item.eng_title }}</div>
            </div>
            <div class="mobileTypeMask hidden-sm-and-up" @click="goPaintingExhibition(item.id)">
              <div class="Itemtitle eng_Itemtitle">{{ item.eng_title }}</div>
            </div>
            <img @click="goPaintingExhibition(item.id)" :src="item.imgSrc" />
          </swiper-slide>
          <!-- 分页器 -->
          <div class="swiper-pagination" slot="pagination"></div>
          <div
            class="swiper-button-prev"
            v-if="detail.categoryList.length > 3"
            slot="button-prev"
          >
            <div>
              <img src="../../assets/mobile/swiperLeft.png" alt="" />
            </div>
          </div>
          <div
            class="swiper-button-next"
            v-if="detail.categoryList.length > 3"
            slot="button-next"
          >
            <div>
              <img src="../../assets/mobile/swiperRight.png" alt="" />
            </div>
          </div>
        </swiper>
        <div class="categoryPart" v-if="categoryList.length >0&&categoryList.length <= 3">
           <div v-for="(item, index) in categoryList" :key="index" class="categoryPartItem">
              <div class="categoryPartItemMask hidden-xs-only" @click="goPaintingExhibition(item.id)">
                <div class="Itemtitle eng_Itemtitle">{{ item.eng_title }}</div>
              </div>
              <div class="categoryPartItemMaskMobile hidden-sm-and-up" @click="goPaintingExhibition(item.id)">
                <div class="Itemtitle eng_Itemtitle">{{ item.eng_title }}</div>
              </div>
              <img :src="item.imgSrc" alt="" />
           </div>
        </div>
        <div class="tangBottom wow animate__fadeInRight animate__animated" v-if="videoLinkList.length>0">
          <div class="videoLink">
            <!-- 大于三个 -->
            <!-- pc -->
            <div class="videoLink_more hidden-xs-only" v-if="videoLinkList.length>3">
              <swiper
                class="videoLink_more_swiper"
                :options="swiperOption"
                v-if="videoLinkList.length > 3"
                ref="mySwiper"
              >
                <swiper-slide
                  class="swiper-slide swiper-slide-videoLink"
                  v-for="(item, index) in videoLinkList"
                  :key="index"
                >
                  <div class="videoLink_little_item_img">
                    <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='video'" :src="url+item.covers" alt="">
                    <img class="videoLink_little_item_img_img" v-if="!item.covers&&item.type=='link'" src="../../assets/exhibitionImage/vr_1.png" alt="">
                    <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='link'" :src="url+item.covers" alt="">
                    <!-- <div class="videoLink_little_item_img_none" v-else></div> -->
                  </div>
                  <div class="videoLink_little_item_text" @click="openVideoLink(item)">
                    <div class="videoLink_little_item_text_video" v-if="item.type=='video'">Video</div>
                    <img class="videoLink_little_item_text_img" src="../../assets/exhibitionImage/vr-1.webp" v-if="item.type=='link'" alt="">
                    <div class="videoLink_little_item_text_link" v-if="item.type=='link'">{{detail.englishName}} VR Tour</div>
                  </div>
                </swiper-slide>
                <!-- 分页器 -->
                <div class="swiper-pagination" slot="pagination"></div>
                <div
                  class="swiper-button-prev"
                  slot="button-prev"
                >
                  <div>
                    <img src="../../assets/mobile/swiperLeft.png" alt="" />
                  </div>
                </div>
                <div
                  class="swiper-button-next"
                  slot="button-next"
                >
                  <div>
                    <img src="../../assets/mobile/swiperRight.png" alt="" />
                  </div>
                </div>
              </swiper>
            </div>
            <!-- mobile -->
            <div class="videoLink_more_mobile hidden-sm-and-up" v-if="videoLinkList.length>3">
              <swiper
                class="videoLink_more_swiper"
                :options="swiperOption"
                v-if="videoLinkList.length > 3"
                ref="mySwiper"
              >
                <swiper-slide
                  class="swiper-slide swiper-slide-videoLink"
                  v-for="(item, index) in videoLinkList"
                  :key="index"
                >
                  <div class="videoLink_little_item_img">
                    <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='video'" :src="url+item.covers" alt="">
                    <img class="videoLink_little_item_img_img" v-if="!item.covers&&item.type=='link'" src="../../assets/exhibitionImage/vr_1.png" alt="">
                    <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='link'" :src="url+item.covers" alt="">
                    <!-- <div class="videoLink_little_item_img_none" v-else></div> -->
                  </div>
                  <div class="videoLink_little_item_text" @click="openVideoLink(item)">
                    <div class="videoLink_little_item_text_video" v-if="item.type=='video'">Video</div>
                    <img class="videoLink_little_item_text_img" src="../../assets/exhibitionImage/vr-1.webp" v-if="item.type=='link'" alt="">
                    <div class="videoLink_little_item_text_link" v-if="item.type=='link'">{{detail.englishName}} VR Tour</div>
                  </div>
                </swiper-slide>
                <!-- 分页器 -->
                <div class="swiper-pagination" slot="pagination"></div>
                <div
                  class="swiper-button-prev"
                  slot="button-prev"
                >
                  <div>
                    <img src="../../assets/mobile/swiperLeft.png" alt="" />
                  </div>
                </div>
                <div
                  class="swiper-button-next"
                  slot="button-next"
                >
                  <div>
                    <img src="../../assets/mobile/swiperRight.png" alt="" />
                  </div>
                </div>
              </swiper>
            </div>
            <!-- 小于或者等于三个 -->
            <div class="videoLink_little" v-if="videoLinkList.length<=3">
              <div class="videoLink_little_item" @click="openVideoLink(item)" v-for="(item, index) in videoLinkList" :key="index">
                <div class="videoLink_little_item_img">
                  <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='video'" :src="url+item.covers" alt="">
                  <img class="videoLink_little_item_img_img" v-if="!item.covers&&item.type=='link'" src="../../assets/exhibitionImage/vr_1.png" alt="">
                  <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='link'" :src="url+item.covers" alt="">
                  <!-- <div class="videoLink_little_item_img_none" v-else></div> -->
                </div>
                <div class="videoLink_little_item_text">
                  <div class="videoLink_little_item_text_video" v-if="item.type=='video'">Video</div>
                  <img class="videoLink_little_item_text_img" src="../../assets/exhibitionImage/vr-1.webp" v-if="item.type=='link'" alt="">
                  <div class="videoLink_little_item_text_link" v-if="item.type=='link'">{{detail.englishName}} VR Tour</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="maskShow" @click.stop.prevent="writeMessageFun($event)">
      <div class="mask_video" ref="modal">
        <div class="seon">
          <div @click="closePlay" class="closeVideo">
            <img src="../../assets/newImage/index/closeVideo.png" alt="" />
          </div>
        </div>
        <div class="mask_box">
          <div class="mask_right">
            <video-player class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                style="object-fit:fill"
                :options="playerOptions"
                :x5-video-player-fullscreen="true"
            >
            </video-player>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="exhibitionDeatil" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibition">
            རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།</router-link
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ detail.zangName }}</span>
        </div>
      </div>
    </div>
    <div class="exhibitionMiddle">
      <div class="section">
        <div class="exhibitionContent">
          <div class="title">
            <div>{{ detail.zangName }}</div>
            <div @click="goBottom" class="gobottom" v-if="detail.zangName">
              {{ detail.zangName }}&nbsp;དྲ་ངོས་བརྩམས་ཆོས་འགྲེམ་སྤེལ།
            </div>
          </div>
          <div class="content" v-if="detail.zangProfile&&detail.zangProfile.replace(/<[^<>]+>/g, '') !== ''">
            <div
              v-if="detail.zangProfile&&detail.zangProfile.replace(/<[^<>]+>/g, '') !== ''"
              class="one wow animate__fadeInDown animate__animated"
              v-html="detail.zangProfile"
            ></div>
          </div>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <!-- 介绍人 -->
    <div class="introduction" v-if="detail.dutyPicture&&detail.dutyPicture.length>0||detail.zangDutyProfile&&detail.zangDutyProfile.replace(/<[^<>]+>/g, '') !== ''">
      <div class="section">
        <div class="characterIntroduction">
          <div class="title" v-if="detail.zangDuty">{{ detail.zangDuty }}མཚམས་སྦྱོར།</div>
          <div class="imgBox" v-if="detail.dutyPicture&&detail.dutyPicture.length>0">
            <div
              class="swiper-containers wow animate__fadeInLeft animate__animated"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide item"
                  v-for="(item, index) in detail.dutyPicture"
                  :key="index"
                >
                  <img
                    v-if="item.fileUrl"
                    class="img"
                    :src="url + item.fileUrl"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="content" v-if="detail.zangDutyProfile.replace(/<[^<>]+>/g, '') !== ''">
            <div
              v-if="detail.zangDutyProfile.replace(/<[^<>]+>/g, '') !== ''"
              class="one wow animate__fadeInDown animate__animated"
              v-html="detail.zangDutyProfile"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="deatilBottom" id="deatilBottom">
      <div class="section">
        <swiper
          :options="swiperOption"
          v-if="categoryList.length > 3"
          ref="mySwiper"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in categoryList"
            :key="index"
            style="
              position: relative;
              overflow: hidden;
              width: 360px;
              height: 266px;
            "
          >
            <div class="typeMask hidden-xs-only" @click="goPaintingExhibition(item.id)">
              <div class="Itemtitle">{{ item.za_title }}</div>
            </div>
            <div class="mobileTypeMask hidden-sm-and-up" @click="goPaintingExhibition(item.id)">
              <div class="Itemtitle">{{ item.za_title }}</div>
            </div>
            <img @click="goPaintingExhibition(item.id)" :src="item.imgSrc" />
          </swiper-slide>
          <!-- 分页器 -->
          <div class="swiper-pagination" slot="pagination"></div>
          <div
            class="swiper-button-prev"
            v-if="detail.categoryList.length > 3"
            slot="button-prev"
          >
            <div>
              <img src="../../assets/mobile/swiperLeft.png" alt="" />
            </div>
          </div>
          <div
            class="swiper-button-next"
            v-if="detail.categoryList.length > 3"
            slot="button-next"
          >
            <div>
              <img src="../../assets/mobile/swiperRight.png" alt="" />
            </div>
          </div>
        </swiper>
        <div class="categoryPart" v-if="categoryList.length >0&&categoryList.length <= 3">
           <div v-for="(item, index) in categoryList" :key="index" class="categoryPartItem">
              <div class="categoryPartItemMask hidden-xs-only" @click="goPaintingExhibition(item.id)">
                <div class="Itemtitle">{{ item.za_title }}</div>
              </div>
              <div class="categoryPartItemMaskMobile hidden-sm-and-up" @click="goPaintingExhibition(item.id)">
                <div class="Itemtitle">{{ item.za_title }}</div>
              </div>
              <img :src="item.imgSrc" alt="" />
           </div>
        </div>
        <div class="tangBottom wow animate__fadeInRight animate__animated" v-if="videoLinkList.length>0">
          <div class="videoLink">
            <!-- 大于三个 -->
            <!-- pc -->
            <div class="videoLink_more hidden-xs-only" v-if="videoLinkList.length>3">
              <swiper
                class="videoLink_more_swiper"
                :options="swiperOption"
                v-if="videoLinkList.length > 3"
                ref="mySwiper"
              >
                <swiper-slide
                  class="swiper-slide swiper-slide-videoLink"
                  v-for="(item, index) in videoLinkList"
                  :key="index"
                >
                  <div class="videoLink_little_item_img">
                    <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='video'" :src="url+item.covers" alt="">
                    <img class="videoLink_little_item_img_img" v-if="!item.covers&&item.type=='link'" src="../../assets/exhibitionImage/vr_1.png" alt="">
                    <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='link'" :src="url+item.covers" alt="">
                    <!-- <div class="videoLink_little_item_img_none" v-else></div> -->
                  </div>
                  <div class="videoLink_little_item_text" @click="openVideoLink(item)">
                    <div class="videoLink_little_item_text_video" v-if="item.type=='video'">བརྙན་འཕྲིན།</div>
                    <img class="videoLink_little_item_text_img" src="../../assets/exhibitionImage/vr-1.webp" v-if="item.type=='link'" alt="">
                    <div class="videoLink_little_item_text_link" v-if="item.type=='link'">{{detail.zangName}}VRའགྲེམ་སྟོན།</div>
                  </div>
                </swiper-slide>
                <!-- 分页器 -->
                <div class="swiper-pagination" slot="pagination"></div>
                <div
                  class="swiper-button-prev"
                  slot="button-prev"
                >
                  <div>
                    <img src="../../assets/mobile/swiperLeft.png" alt="" />
                  </div>
                </div>
                <div
                  class="swiper-button-next"
                  slot="button-next"
                >
                  <div>
                    <img src="../../assets/mobile/swiperRight.png" alt="" />
                  </div>
                </div>
              </swiper>
            </div>
            <!-- mobile -->
            <div class="videoLink_more_mobile hidden-sm-and-up" v-if="videoLinkList.length>3">
              <swiper
                class="videoLink_more_swiper"
                :options="swiperOption"
                v-if="videoLinkList.length > 3"
                ref="mySwiper"
              >
                <swiper-slide
                  class="swiper-slide swiper-slide-videoLink"
                  v-for="(item, index) in videoLinkList"
                  :key="index"
                >
                  <div class="videoLink_little_item_img">
                    <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='video'" :src="url+item.covers" alt="">
                    <img class="videoLink_little_item_img_img" v-if="!item.covers&&item.type=='link'" src="../../assets/exhibitionImage/vr_1.png" alt="">
                    <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='link'" :src="url+item.covers" alt="">
                    <!-- <div class="videoLink_little_item_img_none" v-else></div> -->
                  </div>
                  <div class="videoLink_little_item_text" @click="openVideoLink(item)">
                    <div class="videoLink_little_item_text_video" v-if="item.type=='video'">བརྙན་འཕྲིན།</div>
                    <img class="videoLink_little_item_text_img" src="../../assets/exhibitionImage/vr-1.webp" v-if="item.type=='link'" alt="">
                    <div class="videoLink_little_item_text_link" v-if="item.type=='link'">{{detail.zangName}}VRའགྲེམ་སྟོན།</div>
                  </div>
                </swiper-slide>
                <!-- 分页器 -->
                <div class="swiper-pagination" slot="pagination"></div>
                <div
                  class="swiper-button-prev"
                  slot="button-prev"
                >
                  <div>
                    <img src="../../assets/mobile/swiperLeft.png" alt="" />
                  </div>
                </div>
                <div
                  class="swiper-button-next"
                  slot="button-next"
                >
                  <div>
                    <img src="../../assets/mobile/swiperRight.png" alt="" />
                  </div>
                </div>
              </swiper>
            </div>
            <!-- 小于或者等于三个 -->
            <div class="videoLink_little" v-if="videoLinkList.length<=3">
              <div class="videoLink_little_item" @click="openVideoLink(item)" v-for="(item, index) in videoLinkList" :key="index">
                <div class="videoLink_little_item_img">
                  <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='video'" :src="url+item.covers" alt="">
                  <img class="videoLink_little_item_img_img" v-if="!item.covers&&item.type=='link'" src="../../assets/exhibitionImage/vr_1.png" alt="">
                  <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='link'" :src="url+item.covers" alt="">
                  <!-- <div class="videoLink_little_item_img_none" v-else></div> -->
                </div>
                <div class="videoLink_little_item_text">
                  <div class="videoLink_little_item_text_video" v-if="item.type=='video'">བརྙན་འཕྲིན།</div>
                  <img class="videoLink_little_item_text_img" src="../../assets/exhibitionImage/vr-1.webp" v-if="item.type=='link'" alt="">
                  <div class="videoLink_little_item_text_link" v-if="item.type=='link'">{{detail.zangName}}VRའགྲེམ་སྟོན།</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="maskShow" @click.stop.prevent="writeMessageFun($event)">
      <div class="mask_video" ref="modal">
        <div class="seon">
          <div @click="closePlay" class="closeVideo">
            <img src="../../assets/newImage/index/closeVideo.png" alt="" />
          </div>
        </div>
        <div class="mask_box">
          <div class="mask_right">
            <video-player class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                style="object-fit:fill"
                :options="playerOptions"
                :x5-video-player-fullscreen="true"
            >
            </video-player>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="exhibitionDeatil" v-else>
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibition">热贡作品展</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ detail.chineseName }}</span>
        </div>
      </div>
    </div>
    <div class="exhibitionMiddle">
      <div class="section">
        <div class="exhibitionContent">
          <div class="title">
            <div>{{ detail.chineseName }}</div>
            <div @click="goBottom" class="gobottom" v-if="detail.chineseName">
              {{ detail.chineseName }}在线作品展
            </div>
          </div>
          <div class="content" v-if="detail.chineseProfile&&detail.chineseProfile.replace(/<[^<>]+>/g, '') !== ''">
            <div
              v-if="detail.chineseProfile&&detail.chineseProfile.replace(/<[^<>]+>/g, '') !== ''"
              class="one wow animate__fadeInDown animate__animated"
              v-html="detail.chineseProfile"
            ></div>
          </div>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <!-- 介绍人 -->
    <div class="introduction" v-if="detail.dutyPicture&&detail.dutyPicture.length>0||detail.chineseDutyProfile&&detail.chineseDutyProfile.replace(/<[^<>]+>/g, '') !== ''">
      <div class="section">
        <div class="characterIntroduction">
          <div class="title" v-if="detail.chineseDuty">{{ detail.chineseDuty }}简介</div>
          <div class="imgBox" v-if="detail.dutyPicture&&detail.dutyPicture.length>0">
            <div
              class="swiper-containers wow animate__fadeInLeft animate__animated"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide item"
                  v-for="(item, index) in detail.dutyPicture"
                  :key="index"
                >
                  <img
                    v-if="item.fileUrl"
                    class="img"
                    :src="url + item.fileUrl"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="content" v-if="detail.chineseDutyProfile.replace(/<[^<>]+>/g, '') !== ''">
            <div
              v-if="detail.chineseDutyProfile.replace(/<[^<>]+>/g, '') !== ''"
              class="one wow animate__fadeInDown animate__animated"
              v-html="detail.chineseDutyProfile"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="deatilBottom" id="deatilBottom">
      <div class="section">
        <swiper
          :options="swiperOption"
          v-if="categoryList.length > 3"
          ref="mySwiper"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in categoryList"
            :key="index"
            style="
              position: relative;
              overflow: hidden;
              width: 360px;
              height: 266px;
            "
          >
            <div class="typeMask hidden-xs-only" @click="goPaintingExhibition(item.id)">
              <div class="Itemtitle">{{ item.title }}</div>
            </div>
            <div class="mobileTypeMask hidden-sm-and-up" @click="goPaintingExhibition(item.id)">
              <div class="Itemtitle">{{ item.title }}</div>
            </div>
            <img :src="item.imgSrc" />
          </swiper-slide>
          <!-- 分页器 -->
          <div class="swiper-pagination" slot="pagination"></div>
          <div
            class="swiper-button-prev"
            v-if="detail.categoryList.length > 3"
            slot="button-prev"
          >
            <div>
              <img src="../../assets/mobile/swiperLeft.png" alt="" />
            </div>
          </div>
          <div
            class="swiper-button-next"
            v-if="detail.categoryList.length > 3"
            slot="button-next"
          >
            <div>
              <img src="../../assets/mobile/swiperRight.png" alt="" />
            </div>
          </div>
        </swiper>
        <div class="categoryPart" v-if="categoryList.length >0&&categoryList.length <= 3">
           <div v-for="(item, index) in categoryList" :key="index" class="categoryPartItem">
              <div class="categoryPartItemMask hidden-xs-only" @click="goPaintingExhibition(item.id)">
                <div class="Itemtitle">{{ item.title }}</div>
              </div>
              <div class="categoryPartItemMaskMobile hidden-sm-and-up" @click="goPaintingExhibition(item.id)">
                <div class="Itemtitle">{{ item.title }}</div>
              </div>
              <img :src="item.imgSrc" alt="" />
           </div>
        </div>
        <div class="tangBottom wow animate__fadeInRight animate__animated" v-if="videoLinkList.length>0">
          <div class="videoLink">
            <!-- 大于三个 -->
            <!-- pc -->
            <div class="videoLink_more hidden-xs-only" v-if="videoLinkList.length>3">
              <swiper
                class="videoLink_more_swiper"
                :options="swiperOption"
                v-if="videoLinkList.length > 3"
                ref="mySwiper"
              >
                <swiper-slide
                  class="swiper-slide swiper-slide-videoLink"
                  v-for="(item, index) in videoLinkList"
                  :key="index"
                >
                  <div class="videoLink_little_item_img">
                    <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='video'" :src="url+item.covers" alt="">
                    <img class="videoLink_little_item_img_img" v-if="!item.covers&&item.type=='link'" src="../../assets/exhibitionImage/vr_1.png" alt="">
                    <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='link'" :src="url+item.covers" alt="">
                    <!-- <div class="videoLink_little_item_img_none" v-else></div> -->
                  </div>
                  <div class="videoLink_little_item_text" @click="openVideoLink(item)">
                    <div class="videoLink_little_item_text_video" v-if="item.type=='video'">视频</div>
                    <img class="videoLink_little_item_text_img" src="../../assets/exhibitionImage/vr-1.webp" v-if="item.type=='link'" alt="">
                    <div class="videoLink_little_item_text_link" v-if="item.type=='link'">{{ detail.chineseName }}VR游览</div>
                  </div>
                </swiper-slide>
                <!-- 分页器 -->
                <div class="swiper-pagination" slot="pagination"></div>
                <div
                  class="swiper-button-prev"
                  slot="button-prev"
                >
                  <div>
                    <img src="../../assets/mobile/swiperLeft.png" alt="" />
                  </div>
                </div>
                <div
                  class="swiper-button-next"
                  slot="button-next"
                >
                  <div>
                    <img src="../../assets/mobile/swiperRight.png" alt="" />
                  </div>
                </div>
              </swiper>
            </div>
            <!-- mobile -->
            <div class="videoLink_more_mobile hidden-sm-and-up" v-if="videoLinkList.length>3">
              <swiper
                class="videoLink_more_swiper"
                :options="swiperOption"
                v-if="videoLinkList.length > 3"
                ref="mySwiper"
              >
                <swiper-slide
                  class="swiper-slide swiper-slide-videoLink"
                  v-for="(item, index) in videoLinkList"
                  :key="index"
                >
                  <div class="videoLink_little_item_img">
                    <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='video'" :src="url+item.covers" alt="">
                    <img class="videoLink_little_item_img_img" v-if="!item.covers&&item.type=='link'" src="../../assets/exhibitionImage/vr_1.png" alt="">
                    <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='link'" :src="url+item.covers" alt="">
                    <!-- <div class="videoLink_little_item_img_none" v-else></div> -->
                  </div>
                  <div class="videoLink_little_item_text" @click="openVideoLink(item)">
                    <div class="videoLink_little_item_text_video" v-if="item.type=='video'">视频</div>
                    <img class="videoLink_little_item_text_img" src="../../assets/exhibitionImage/vr-1.webp" v-if="item.type=='link'" alt="">
                    <div class="videoLink_little_item_text_link" v-if="item.type=='link'">{{ detail.chineseName }}VR游览</div>
                  </div>
                </swiper-slide>
                <!-- 分页器 -->
                <div class="swiper-pagination" slot="pagination"></div>
                <div
                  class="swiper-button-prev"
                  slot="button-prev"
                >
                  <div>
                    <img src="../../assets/mobile/swiperLeft.png" alt="" />
                  </div>
                </div>
                <div
                  class="swiper-button-next"
                  slot="button-next"
                >
                  <div>
                    <img src="../../assets/mobile/swiperRight.png" alt="" />
                  </div>
                </div>
              </swiper>
            </div>
            <!-- 小于或者等于三个 -->
            <div class="videoLink_little" v-if="videoLinkList.length<=3">
              <div class="videoLink_little_item" @click="openVideoLink(item)" v-for="(item, index) in videoLinkList" :key="index">
                <div class="videoLink_little_item_img">
                  <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='video'" :src="url+item.covers" alt="">
                  <img class="videoLink_little_item_img_img" v-if="!item.covers&&item.type=='link'" src="../../assets/exhibitionImage/vr_1.png" alt="">
                  <img class="videoLink_little_item_img_img" v-if="item.covers&&item.type=='link'" :src="url+item.covers" alt="">
                  <!-- <div class="videoLink_little_item_img_none" v-else></div> -->
                </div>
                <div class="videoLink_little_item_text">
                  <div class="videoLink_little_item_text_video" v-if="item.type=='video'">视频</div>
                  <img class="videoLink_little_item_text_img" src="../../assets/exhibitionImage/vr-1.webp" v-if="item.type=='link'" alt="">
                  <div class="videoLink_little_item_text_link" v-if="item.type=='link'">{{ detail.chineseName }}VR游览</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="maskShow" @click.stop.prevent="writeMessageFun($event)">
      <div class="mask_video" ref="modal">
        <div class="seon">
          <div @click="closePlay" class="closeVideo">
            <img src="../../assets/newImage/index/closeVideo.png" alt="" />
          </div>
        </div>
        <div class="mask_box">
          <div class="mask_right">
            <video-player class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                style="object-fit:fill"
                :options="playerOptions"
                :x5-video-player-fullscreen="true"
            >
            </video-player>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { templeGet } from "../../api/management";
import Swiper from "swiper";
import PicTop from "../../components/picsTop.vue";
import "swiper/dist/css/swiper.min.css";
export default {
  components: {
    PicTop,
  },
  data() {
    return {
      language: this.$store.state.language,
      width: "500",
      height: "500",
      url: process.env.VUE_APP_WEB_URL,
      detail: {},
      id: this.$route.query.id, //画院id
      tangList: [
        {
          id: 1,
          imgSrc: require("../../assets/exhibitionImage/tangOne_1.png"),
          title: "唐卡",
          za_title: " ཐང་ག ",
          eng_title: "Thangka",
        },
        {
          id: 2,
          imgSrc: require("../../assets/dataType/data_ni.jpg"),
          title: "泥塑",
          za_title: " འཇིམ་བཟོ། ",
          eng_title: "Clay sculpture",
        },
        {
          id: 3,
          imgSrc: require("../../assets/dataType/buhua.png"),
          title: "壁画",
          za_title: "ལྡེབས་རིས།",
          eng_title: "Mural",
        },
        {
          id: 4,
          imgSrc: require("../../assets/dataType/data_dui.png"),
          title: "堆绣",
          za_title: " དྲས་དྲུབ། ",
          eng_title: "Pile embroidery",
        },
        {
          id: 5,
          imgSrc: require("../../assets/dataType/data_cai.png"),
          title: "彩绘",
          za_title: " ཚོན་རིས། ",
          eng_title: "Paintings",
        },
        {
          id: 6,
          imgSrc: require("../../assets/dataType/other.jpg"),
          title: "其他类",
          za_title: " རིགས་གཞན་དག་ ",
          eng_title: "Other",
        },
      ],
      tangVideoList: [
        {
          imgSrc: require("../../assets/exhibitionImage/tangFour.png"),
          title: "ཉར་དངོས།",
          za_title: "ཉར་དངོས།",
          eng_title: "Collection",
        },
        {
          imgSrc: require("../../assets/exhibitionImage/tangFive.png"),
          title: "热贡画院VR游览",
          za_title: "རེབ་གོང་ལྷ་རིས་གླིངVRའགྲེམ་སྟོན།་",
          eng_title: "Regong Art Academy VR Tour",
        },
      ],
      showPlay: false,
      swiperOption: {
        loop: false, //是否循环轮播
        slidesPerView: 3,
        spaceBetween: 15,
        //左右切换
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      categoryList: [],
      maskShow: false,
      videoUrl: "", //单个视频路径
      videoSrc: "",
      videoList: [],
      link: "",
      currsorIndex: 0,
      playerOptions: {
          playbackRates: [0.7, 1.0, 1.25, 1.5, 2.0], //播放速度
          autoplay: true, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
              type: "video/mp4",
              src:""
          }],
          poster: "",
          // width: document.documentElement.clientWidth,
          notSupportedMessage: '', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
              progressControl: true, //是否显示进度条
              fullscreenToggle: false  //全屏按钮
          }
      },
      defaultImage: require("../../assets/indexImage/index_3.png"),
      videoLinkList:[]
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  created() {
    this.getTempleGet();
  },
  mounted() {
    this.maskShow = false;
    new this.$wow.WOW().init();
  },
  methods: {
    onImageError(event) {
      // 将事件目标的src设置为默认图片
      event.target.src = this.defaultImage;
    },
    async getTempleGet() {
      const res = await templeGet(this.id);
      if (res.code == 1) {
        this.videoList = res.data.videos;
        this.link = res.data.link;
        this.getInitTwo();
        this.detail = res.data;
        this.getVideoAndLink();
        this.detail.chineseProfile = this.detail.chineseProfile.replace(
          /<img/g,
          "<img style='width:80%;display:block;margin:0 auto;'"
        );
        this.detail.englishProfile = this.detail.englishProfile.replace(
          /<img/g,
          "<img style='width:80%;display:block;margin:0 auto;'"
        );
        this.detail.zangProfile = this.detail.zangProfile.replace(
          /<img/g,
          "<img style='width:80%;display:block;margin:0 auto;'"
        );
        this.detail.chineseDutyProfile = this.detail.chineseDutyProfile.replace(
          /<img/g,
          "<img style='width:30%;display:block;margin:0 auto;'"
        );
        this.detail.englishDutyProfile = this.detail.englishDutyProfile.replace(
          /<img/g,
          "<img style='width:30%;display:block;margin:0 auto;'"
        );
        this.detail.zangDutyProfile = this.detail.zangDutyProfile.replace(
          /<img/g,
          "<img style='width:30%;display:block;margin:0 auto;'"
        );
        let category = res.data.categoryList;
        for (var i = 0; i < category.length; i++) {
          for (var j = 0; j < this.tangList.length; j++) {
            if (category[i].id == this.tangList[j].id) {
              this.categoryList.push(this.tangList[j]);
            }
          }
        }
      }
    },
    goOpenLink() {
      let link = this.link
      if(!link) {
        return this.$message("暂无VR链接");
      } else {
        window.open(link,'_blank')
      }
    },
    goPaintingExhibition(id) {
      let category = id;
      this.$router.push({
        path: "/paintingExhibition",
        query: { id: this.id, type: category },
      });
    },
    getInitTwo() {
      this.$nextTick(() => {
        new Swiper(".swiper-containers", {
          loop: true, // 循环模式选项
          autoplay: 2000, //可选选项，自动滑动
          autoplayDisableOnInteraction: false,
          observer: true,
        });
      });
    },
    videoPlay() {
      if(this.videoList.length<1) {
        return this.$message("暂无视频");
      } else {
        this.maskShow = true;
        this.videoUrl = this.url + this.videoList[0].fileUrl;
        this.playerOptions.sources[0].src = this.url + this.videoList[0].fileUrl
        let body = document.getElementsByTagName('body')[0]
        body.style.overflow='hidden'
      }
    },
    goBottom() {
      document.querySelector("#deatilBottom").scrollIntoView(true);
    },
    closePlay() {
      this.maskShow = false;
      let body = document.getElementsByTagName('body')[0]
      body.style.overflow=null
    },
    writeMessageFun (ev) {
      let dom = this.$refs.modal
      if(dom) {
        if(!dom.contains(ev.target)) {
          this.maskShow = false;
          let body = document.getElementsByTagName('body')[0]
          body.style.overflow=null
        }
      }
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
    // 处理视频和链接
    getVideoAndLink() {
      let list = []
      let videoList = this.detail.videos
      if(videoList.length>0) {
        let videoCovers = this.detail.videoCovers
        for (let i = 0; i < videoList.length; i++) {
          list.push(
            {
              type:'video',
              fileUrl:videoList[i].fileUrl,
              fileName:videoList[i].fileName,
              covers:videoCovers.length==0?'' : videoList.length==videoCovers.length?videoCovers[i].fileUrl:videoCovers[0].fileUrl
            }
          )
        }
      }
      if(this.detail.link) {
        let vrCovers = this.detail.vrCovers
        list.push(
          {
            type:'link',
            fileUrl:this.detail.link,
            fileName:this.detail.link,
            covers:vrCovers.length>0?vrCovers[0].fileUrl:''
          }
        )
      }
      this.videoLinkList = list
    },
    openVideoLink(item) {
      if(item.type=='video') {
        this.maskShow = true;
        this.videoUrl = this.url + item.fileUrl;
        this.playerOptions.sources[0].src = this.url + item.fileUrl
        let body = document.getElementsByTagName('body')[0]
        body.style.overflow='hidden'
      } else {
        window.open(item.fileUrl,'_blank')
      }
    }
  },
};
</script>
<style lang="scss">
.exhibitionDeatil {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  position: relative;
  background-size: 7%;
  .exhibitionTop {
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
  }
  .exhibitionMiddle {
    position: relative;
    .section {
      .exhibitionContent {
        .title {
          position: relative;
          font-size: 30px;
          font-family: "fangzang";
          text-align: center;
          padding: 30px 0;
          span {
            cursor: pointer;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(50%);
            font-size: 18px;
          }
          span:hover {
            color: #791824;
          }
        }
        .eng_title {
          font-family: "Times New Roman", Times, serif;
        }
        .content {
          text-align: justify;
          padding: 15px 0 20px 0;
          p {
            font-size: 16px;
            line-height: 1.5;
            margin-bottom: 16px;
            text-indent: 2em;
          }
          .one {
            display: flex;
            flex-direction: column;
            justify-content: center;
            p {
              font-size: 16px;
              line-height: 1.5;
              margin-bottom: 16px;
              text-indent: 2em;
            }
          }
          h4 {
            text-indent: 2em;
            font-size: 16px;
            line-height: 1.5;
            margin-bottom: 16px;
          }
          div {
            text-indent: 2em;
            font-size: 16px;
            line-height: 1.5;
            margin-bottom: 16px;
          }
        }
        .eng_content .one > div {
          font-size: 16px;
          text-indent: 0;
          line-height: 1.5;
          margin-bottom: 16px;
        }
        .eng_content .one p {
          font-size: 16px;
          text-indent: 0;
          line-height: 1.5;
          margin-bottom: 16px;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: -50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .introduction {
    padding-bottom: 40px;
    background: url("../../assets/exhibitionImage/niangBgc.png") repeat center
      center;
    .section {
      .characterIntroduction {
        .title {
          text-align: center;
          padding: 40px 0;
          font-size: 30px;
          font-family: "fangzang";
        }
        .eng_title {
          font-family: "Times New Roman", Times, serif;
        }
        .imgBox {
          display: flex;
          justify-content: center;
          .swiper-containers {
            width: 600px !important;
            overflow: hidden;
            .swiper-wrapper {
              display: flex;
              .swiper-slide {
                width: 600px !important;
              }
              img {
                width: 100%;
              }
            }
          }
        }
        .content {
          text-align: justify;
          margin-top: 20px;
          .one {
            margin-top: 10px;
            font-size: 16px;
            line-height: 1.5;
          }
        }
        .content .one > div,
        .content .one > p {
          margin-top: 10px;
          text-indent: 2em;
          font-size: 16px;
          line-height: 1.5;
        }
        .eng_content .one > div {
          text-indent: 0;
        }
        .eng_content .one > p {
          text-indent: 0;
        }
        .eng_content .one {
          text-indent: 0;
        }
      }
    }
  }
  .deatilBottom {
    margin: 50px 0;
    .section {
      .tangTop {
        display: flex;
        justify-content: space-between;
        overflow: hidden;
        position: relative;
      }
      .swiper-container {
        .swiper-wrapper {
          width: 390px !important;
          height: 266px !important;
          .swiper-slide {
            position: relative;
            margin-right: 10px;
            cursor: pointer;
            .Itemtitle {
              position: absolute;
              font-size: 34px;
              font-family: "fangzang";
              top: 50%;
              left: 50%;
              color: #f4f5f6;
              text-align: center;
              transform: translate(-50%, -50%);
            }
            .eng_Itemtitle {
              font-family: "Times New Roman", Times, serif;
            }
            img {
              height: 100%;
              width: 100% !important;
            }
            .typeMask {
              position: absolute;
              left: 0;
              bottom: -266px;
              width: 100%;
              height: 266px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgba(0, 0, 0, 0.3);
              transition: all 0.5s linear;
            }
          }
          .swiper-slide:hover {
            .typeMask {
              transform: translateY(-266px);
              animation-play-state: running;
            }
          }
        }
        .swiper-button-prev::after {
          content: "";
        }
        .swiper-button-prev {
          position: absolute;
          background: none;
          background-color: #9a141b;
          width: 22px;
          height: 60px;
          left: 0;
          opacity: 1;
        }
        .swiper-button-next::after {
          content: "";
        }
        .swiper-button-next {
          position: absolute;
          background: none;
          background-color: #9a141b;
          width: 22px;
          height: 60px;
          right: 0;
        }
      }
      .categoryPart {
        display: flex;
        justify-content: center;
        .categoryPartItem {
          position: relative;
          width: 390px !important;
          height: 266px !important;
          margin-right: 10px;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
          .categoryPartItemMask {
            position: absolute;
            left: 0;
            bottom: -266px;
            width: 100%;
            height: 266px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: rgba(0, 0, 0, 0.3);
            transition: all 0.5s linear;
            .Itemtitle {
              position: absolute;
              font-size: 34px;
              font-family: "fangzang";
              top: 50%;
              left: 50%;
              color: #f4f5f6;
              text-align: center;
              transform: translate(-50%, -50%);
            }
            .eng_Itemtitle {
              font-family: "Times New Roman", Times, serif;
            }
          }
        }
        .categoryPartItem:last-child {
          margin-right: 0;
        }
        .categoryPartItem:hover {
            .categoryPartItemMask {
              transform: translateY(-266px);
              animation-play-state: running;
            }
        }
      }
      .tangBottom {
        width: 100%;
        margin-top: 40px;
        display: flex;
        justify-content: center;
        .videoLink {
          width: 100%;
          .videoLink_more {
            width: 100%;
            .videoLink_more_swiper {
              width: 100%;
              .swiper-wrapper {
                width: 100%;
                .swiper-slide {
                  width: 390px !important;
                  height: 266px !important;
                  position: relative;
                  .videoLink_little_item_img {
                    width: 100%;
                    height: 100%;
                    .videoLink_little_item_img_img {
                      width: 100%;
                      height: 100%;
                    }
                    .videoLink_little_item_img_none {
                      width: 100%;
                      height: 100%;
                      background-color: rgba(47, 66, 101, 0.8);
                    }
                  }
                  .videoLink_little_item_text {
                    position: absolute;
                    left: 0;
                    bottom: -266px;
                    width: 100%;
                    height: 266px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    background-color: rgba(0, 0, 0, 0.3);
                    transition: all 0.5s linear;
                    color: #ffffff;
                    font-size: 24px;
                    font-family: "fangzang";
                    color: #f4f5f6;
                    .videoLink_little_item_text_video {
                      // 自动换行
                      width: 90%;
                      word-break: break-all;
                      white-space: pre-warp;
                      text-align: center;
                    }
                    .videoLink_little_item_text_img {
                      width: 100px!important;
                      height: 100px;
                      margin-bottom: 10px;
                    }
                    .videoLink_little_item_text_link {
                      // 自动换行
                      width: 90%;
                      word-break: break-all;
                      white-space: pre-warp;
                      text-align: center;
                    }
                  }
                }
                .swiper-slide-videoLink:hover {
                  .videoLink_little_item_text {
                    transform: translateY(-266px);
                    animation-play-state: running;
                  }
                }
              }
            }
          }
          .videoLink_little {
            display: flex;
            justify-content: center;
            .videoLink_little_item {
              width: 390px !important;
              height: 266px !important;
              position: relative;
              margin-right: 15px;
              overflow: hidden;
              cursor: pointer;
              .videoLink_little_item_img {
                width: 100%;
                height: 100%;
                .videoLink_little_item_img_img {
                  width: 100%;
                  height: 100%;
                }
                .videoLink_little_item_img_none {
                  width: 100%;
                  height: 100%;
                  background-color: rgba(47, 66, 101, 0.8);
                }
              }
              .videoLink_little_item_text {
                position: absolute;
                left: 0;
                bottom: -266px;
                width: 100%;
                height: 266px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                background-color: rgba(0, 0, 0, 0.3);
                transition: all 0.5s linear;
                color: #ffffff;
                font-size: 24px;
                font-family: "fangzang";
                color: #f4f5f6;
                .videoLink_little_item_text_video {
                  // 自动换行
                  width: 90%;
                  word-break: break-all;
                  white-space: pre-warp;
                  text-align: center;
                }
                .videoLink_little_item_text_img {
                  width: 100px!important;
                  height: 100px;
                  margin-bottom: 10px;
                }
                .videoLink_little_item_text_link {
                  // 自动换行
                  width: 90%;
                  word-break: break-all;
                  white-space: pre-warp;
                  text-align: center;
                }
              }
            }
            .videoLink_little_item:hover {
                .videoLink_little_item_text {
                  transform: translateY(-266px);
                  animation-play-state: running;
                }
            }
            .videoLink_little_item:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
  .goBottom {
    z-index: 999;
    display: flex;
    align-items: center;
    position: fixed;
    top: 80%;
    right: 0;
    cursor: pointer;
    .imgBox {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 90px;
      height: 90px;
      border-radius: 100%;
      background-color: #971118;
      box-shadow: 0 0 10px #971118;
      margin-bottom: 20px;
      font-size: 16px;
      img {
        width: 40px;
        height: 40px;
      }
      .text {
        color: #fff;
      }
    }
  }
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    padding: 30px 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    .mask_video {
      position: relative;
      width: 1000px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 400px;
      .seon {
        height: 400px;
        position: absolute;
        display: flex;
        right: 0;
        top: 0;
        .closeVideo {
          z-index: 9999;
          position: absolute;
          top: 0;
          right: 0;
          background-color: #981118;
          width: 40px;
          height: 40px;
          border-radius: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 30px;
          }
        }
      }
      .mask_box {
        width: 100%;
        height: 100%;
        display: flex;
        .mask_right {
          width: calc(100% - 60px);
          video {
            width: 100%;
          }
          .video-player {
            .video-js {
              .vjs-control-bar {
                .vjs-progress-control {
                  .vjs-progress-holder {
                    .vjs-play-progress:before {
                      top: 1px;
                    }
                  }
                }
                .vjs-volume-panel{
                  .vjs-volume-control {
                    .vjs-volume-bar {
                      .vjs-volume-level:before {
                        top: 1px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .exhibitionDeatil {
    background-size: 15%;
    position: relative;
    padding: 0 0 0.6rem 0;
    .exhibitionTop {
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.28rem;
        .section_left {
          left: 0.2rem;
        }
      }
      .eng_section {
        font-size: 0.26rem;
      }
    }
    .exhibitionMiddle {
      .section {
        .exhibitionContent {
          .title {
            font-size: 0.4rem;
            padding: 0.3rem;
            .gobottom {
              font-size: 0.3rem;
            }
          }
          .content {
            max-height: 10rem;
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE 10+ */
            overflow: scroll;
          }
          .content::-webkit-scrollbar {
            display: none; /* Chrome Safari */
          }
        }
      }
    }
    .introduction {
      padding-bottom: 0.1rem;
      .section {
        background: url("../../assets/exhibitionImage/niangBgc.png") repeat
          center center;
        .characterIntroduction {
          .title {
            font-size: 0.5rem;
            padding: 0.3rem 0 !important;
          }
          .content {
            padding-bottom: 0.2rem;
            text-align: justify;
          }
          .imgBox {
            .swiper-containers {
              position: relative;
              width: 7rem !important;
              // height: 4.5rem !important;
              .swiper-wrapper {
                .swiper-slide {
                  width: 7rem !important;
                  // height: 4.5rem !important;
                  text-align: center;
                  .img {
                    width: 5rem !important;
                    // height: 4.5rem !important;
                  }
                }
              }
            }
          }
        }
      }
    }
    .deatilBottom {
      background: none;
      margin: 0;
      margin-top: 0.5rem;
      padding-bottom: 0.5rem;
      .section {
        .swiper-container {
          .swiper-wrapper {
            width: 2.155rem !important;
            height: 1.6rem !important;
            .swiper-slide {
              width: 2.155rem !important;
              height: 1.6rem !important;
              margin-right: 0.15rem;
              position: relative;
              .img {
                width: 2.155rem !important;
                height: 1.6rem !important;
              }
              .Itemtitle {
                font-size: 0.3rem;
              }
              .mobileTypeMask {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 1.6rem;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: rgba(0, 0, 0, 0.3);
              }
            }
          }
          .swiper-button-prev::after {
            content: "";
          }
          .swiper-button-prev {
            position: absolute;
            background: none;
            background-color: #9a141b;
            height: 0.6rem;
            width: 0.3rem;
            left: 0;
            top: 1rem;
          }
          .swiper-button-next::after {
            content: "";
          }
          .swiper-button-next {
            position: absolute;
            background: none;
            background-color: #9a141b;
            height: 0.6rem;
            width: 0.3rem;
            right: 0.05rem;
            top: 1rem;
          }
        }
        .categoryPart {
          display: flex;
          justify-content: center;
          .categoryPartItem {
            position: relative;
            width: 2.155rem !important;
            height: 1.6rem !important;
            margin-right: 0.15rem;
            overflow: hidden;
            cursor: pointer;
            img {
              width: 2.155rem !important;
              height: 1.6rem !important;
            }
            .categoryPartItemMaskMobile {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 1.6rem;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgba(0, 0, 0, 0.3);
              .Itemtitle {
                font-size: 0.3rem;
                position: absolute;
                font-family: "fangzang";
                top: 50%;
                left: 50%;
                color: #f4f5f6;
                text-align: center;
                transform: translate(-50%, -50%);
              }
              .eng_Itemtitle {
                font-family: "Times New Roman", Times, serif;
              }
            }
          }
        }
        .tangBottom {
          width: 100%;
          margin-top: 0.3rem;
          display: flex;
          justify-content: center;
          .videoLink_more_mobile {
            width: 100%;
            .videoLink_more_swiper {
              width: 100%;
              .swiper-wrapper {
                width: 100%;
                .swiper-slide {
                  width: 2.155rem !important;
                  height: 1.6rem !important;
                  position: relative;
                  .videoLink_little_item_img {
                    width: 100%;
                    height: 100%;
                    .videoLink_little_item_img_img {
                      width: 100%;
                      height: 100%;
                    }
                    .videoLink_little_item_img_none {
                      width: 100%;
                      height: 100%;
                      background-color: rgba(47, 66, 101, 0.8);
                    }
                  }
                  .videoLink_little_item_text {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 1.6rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    background-color: rgba(0, 0, 0, 0.3);
                    transition: all 0.5s linear;
                    color: #ffffff;
                    font-size: 0.25rem;
                    font-family: "fangzang";
                    color: #f4f5f6;
                    text-align: center;
                    .videoLink_little_item_text_img {
                      width: .5rem!important;
                      height: .5rem;
                      margin-bottom: .05rem;
                    }
                  }
                }
                .swiper-slide-videoLink:hover {
                  .videoLink_little_item_text {
                    transform: translateY(-0);
                    animation-play-state: running;
                  }
                }
              }
            }
          }
          .videoLink {
            width: 100%;
            .videoLink_little {
              display: flex;
              justify-content: center;
              .videoLink_little_item {
                width: 2.155rem !important;
                height: 1.6rem !important;
                margin-right: 0.15rem;
                .videoLink_little_item_text {
                  position: absolute;
                  top: 0;
                  left: 0;
                  font-size: .25rem;
                  height: 100%;
                  .videoLink_little_item_text_img {
                    width: .5rem!important;
                    height: .5rem;
                    margin-bottom: .05rem;
                  }
                }
              }
              .videoLink_little_item:hover {
                  .videoLink_little_item_text {
                    transform: translateY(0);
                  }
              }
            }
          }
        }
      }
    }
    .goBottom {
      top: 70%;
      .imgBox {
        width: 1.2rem;
        height: 1.2rem;
        img {
          width: 0.5rem;
          height: 0.5rem;
        }
        .text {
          font-size: 0.2rem;
        }
      }
    }
    .mask {
      .mask_video {
        padding: 0;
        .seon {
          .closeVideo {
            top: 0;
            width: 25px;
            height: 25px;
            img {
              width: 15px;
            } 
          }
        }
        .mask_box {
          flex-direction: column;
          .mask_left{
            width: 100%;
            height: 200px;
            .maskItem {
              font-size: .3rem;
              line-height: .6rem;
            }
          }
          .mask_right {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
